
// export const IMAGE_CDN_URL =
//   "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/"
export const IMAGE_CDN_URL =
  'https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/'
export const FETCH_MENU_URL =
  'https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=27.2074205&lng=78.01525769999999&restaurantId='

export const restaurantList = [
  {
    info: {
      id: '254105',
      name: "McDonald's",
      cloudinaryImageId: '08eee882fda81b68e5c36e3a5d89d8c0',
      locality: 'Cosmos Mall',
      areaName: 'Civil Lines',
      costForTwo: '₹400 for two',
      cuisines: ['American'],
      avgRating: 4,
      feeDetails: {
        restaurantId: '254105',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '630',
      avgRatingString: '4.0',
      totalRatingsString: '5K+',
      sla: {
        deliveryTime: 19,
        lastMileTravel: 1.7,
        serviceability: 'SERVICEABLE',
        slaString: '19 mins',
        lastMileTravelString: '1.7 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-28 01:30:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      aggregatedDiscountInfoV2: {},
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/mcdonalds-cosmos-mall-civil-lines-agra-254105',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '432387',
      name: 'The Belgian Waffle Co.',
      cloudinaryImageId: 'occhznrolgw9kg8mmvbf',
      locality: 'Wazirpura Road',
      areaName: 'Civil Lines',
      costForTwo: '₹200 for two',
      cuisines: ['Waffle', 'Desserts', 'Ice Cream', 'Beverages'],
      avgRating: 4.3,
      veg: true,
      feeDetails: {
        restaurantId: '432387',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '2233',
      avgRatingString: '4.3',
      totalRatingsString: '500+',
      sla: {
        deliveryTime: 23,
        lastMileTravel: 1.5,
        serviceability: 'SERVICEABLE',
        slaString: '23 mins',
        lastMileTravelString: '1.5 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-27 23:55:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      aggregatedDiscountInfoV2: {},
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/the-belgian-waffle-co-wazirpura-road-civil-lines-agra-432387',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '79628',
      name: 'Bhawna Sweets',
      cloudinaryImageId: 'ij5lrqmlvgwr6wz8iawj',
      locality: 'Madiya Katra',
      areaName: 'Lohamandi',
      costForTwo: '₹200 for two',
      cuisines: ['Sweets', 'Snacks', 'Bakery'],
      avgRating: 3.6,
      veg: true,
      feeDetails: {
        restaurantId: '79628',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '13641',
      avgRatingString: '3.6',
      totalRatingsString: '10K+',
      sla: {
        deliveryTime: 20,
        lastMileTravel: 3,
        serviceability: 'SERVICEABLE',
        slaString: '20 mins',
        lastMileTravelString: '3.0 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-27 23:15:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: '₹125 OFF',
        subHeader: 'ABOVE ₹199',
        discountTag: 'FLAT DEAL',
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/bhawna-sweets-madiya-katra-lohamandi-agra-79628',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '676056',
      name: 'Kwality Walls Frozen Dessert and Ice Cream Shop',
      cloudinaryImageId: '9a1faf1fc5687af9a759d98d89f410b3',
      locality: 'Farzan Hariparwat Ward',
      areaName: 'Civil Lines',
      costForTwo: '₹200 for two',
      cuisines: ['Ice Cream', 'Desserts'],
      avgRating: 4.2,
      feeDetails: {
        restaurantId: '676056',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '582',
      avgRatingString: '4.2',
      totalRatingsString: '100+',
      sla: {
        deliveryTime: 16,
        lastMileTravel: 2,
        serviceability: 'SERVICEABLE',
        slaString: '16 mins',
        lastMileTravelString: '2.0 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-27 23:15:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: '20% OFF',
        subHeader: 'UPTO ₹50',
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
      isNewlyOnboarded: true,
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/kwality-walls-frozen-dessert-and-ice-cream-shop-farzan-hariparwat-ward-civil-lines-agra-676056',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '103442',
      name: 'Awadhi Foods',
      cloudinaryImageId: 'hddibbmxghxjkwevbhs6',
      locality: 'Sanjay Palace',
      areaName: 'Civil Lines',
      costForTwo: '₹200 for two',
      cuisines: ['North Indian'],
      avgRating: 3.6,
      veg: true,
      feeDetails: {
        restaurantId: '103442',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '13552',
      avgRatingString: '3.6',
      totalRatingsString: '10K+',
      sla: {
        deliveryTime: 15,
        lastMileTravel: 1.9,
        serviceability: 'SERVICEABLE',
        slaString: '15 mins',
        lastMileTravelString: '1.9 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-27 22:40:00',
        opened: true,
      },
      badges: {},
      select: true,
      isOpen: true,
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: '₹125 OFF',
        subHeader: 'ABOVE ₹199',
        discountTag: 'FLAT DEAL',
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/awadhi-foods-sanjay-palace-civil-lines-agra-103442',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '102953',
      name: 'GMB-Gopika Sweets & Restaurant',
      cloudinaryImageId: 'l6iqlfn5uwesenzcm0xk',
      locality: 'Jeoni Mandi',
      areaName: 'Jeoni Mandi',
      costForTwo: '₹300 for two',
      cuisines: ['Sweets', 'North Indian', 'Snacks'],
      avgRating: 4.2,
      feeDetails: {
        restaurantId: '102953',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '87777',
      avgRatingString: '4.2',
      totalRatingsString: '1K+',
      sla: {
        deliveryTime: 19,
        lastMileTravel: 1.8,
        serviceability: 'SERVICEABLE',
        slaString: '19 mins',
        lastMileTravelString: '1.8 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-27 23:00:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: '20% OFF',
        subHeader: 'UPTO ₹50',
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/gmb-gopika-sweets-and-restaurant-jeoni-mandi-agra-102953',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '74562',
      name: 'Bhagat Halwai (Dayal Bagh)',
      cloudinaryImageId: 'crfkxcc5jbvdgmxioey2',
      locality: 'Shahganj',
      areaName: 'Dayal Bagh',
      costForTwo: '₹250 for two',
      cuisines: ['Chinese', 'North Indian', 'Sweets', 'South Indian', 'Chaat'],
      avgRating: 4,
      veg: true,
      feeDetails: {
        restaurantId: '74562',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '13659',
      avgRatingString: '4.0',
      totalRatingsString: '10K+',
      sla: {
        deliveryTime: 20,
        lastMileTravel: 2.5,
        serviceability: 'SERVICEABLE',
        slaString: '20 mins',
        lastMileTravelString: '2.5 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-27 22:00:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      aggregatedDiscountInfoV2: {},
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/bhagat-halwai-dayal-bagh-shahganj-dayal-bagh-agra-74562',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '137924',
      name: 'Raj Rasoi Sweets & Restaurant',
      cloudinaryImageId: 'nwr8wksyyakepe4prpjy',
      locality: 'Sanjay Place',
      areaName: 'Sanjay Place',
      costForTwo: '₹300 for two',
      cuisines: ['South Indian', 'North Indian', 'Snacks', 'Sweets'],
      avgRating: 4.1,
      veg: true,
      feeDetails: {
        restaurantId: '137924',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '13498',
      avgRatingString: '4.1',
      totalRatingsString: '5K+',
      sla: {
        deliveryTime: 20,
        lastMileTravel: 2,
        serviceability: 'SERVICEABLE',
        slaString: '20 mins',
        lastMileTravelString: '2.0 km',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-27 22:30:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: '40% OFF',
        subHeader: 'UPTO ₹80',
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/raj-rasoi-sweets-and-restaurant-sanjay-place-agra-137924',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
  {
    info: {
      id: '449450',
      name: "Domino's Pizza",
      cloudinaryImageId: 'anpghutnnzmjxcvmfjyn',
      locality: 'Vijay Market',
      areaName: 'Dayal Bagh',
      costForTwo: '₹400 for two',
      cuisines: ['Pizzas', 'Italian', 'Pastas', 'Desserts'],
      avgRating: 4.3,
      feeDetails: {
        restaurantId: '449450',
        fees: [
          {
            name: 'BASE_DISTANCE',
            fee: 1900,
          },
          {
            name: 'BASE_TIME',
          },
          {
            name: 'ANCILLARY_SURGE_FEE',
          },
        ],
        totalFee: 1900,
      },
      parentId: '2456',
      avgRatingString: '4.3',
      totalRatingsString: '100+',
      sla: {
        deliveryTime: 25,
        serviceability: 'SERVICEABLE',
        slaString: '25 mins',
        iconType: 'ICON_TYPE_EMPTY',
      },
      availability: {
        nextCloseTime: '2023-07-28 00:55:00',
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: 'F',
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: '₹125 OFF',
        subHeader: 'ABOVE ₹999',
        discountTag: 'FLAT DEAL',
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
        differentiatedUiMediaDetails: {
          mediaType: 'ADS_MEDIA_ENUM_IMAGE',
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
    },
    analytics: {
      context: 'seo-data-7c88cb2c-5ffe-4382-a4f9-05c4d13fc989',
    },
    cta: {
      link: 'https://www.swiggy.com/restaurants/dominos-pizza-vijay-market-dayal-bagh-agra-449450',
      text: 'RESTAURANT_MENU',
      type: 'WEBLINK',
    },
    widgetId: 'collectionV5RestaurantListWidget_SimRestoRelevance_food_seo',
  },
]